import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { HelmetProvider } from 'react-helmet-async'
import { initializeAnalytics } from './utils/analytics.js'
import { initPerformanceMode } from './utils/performanceMode.js'
import { captureEnquiryLandingPage } from './utils/enquiries.js'

initPerformanceMode()
captureEnquiryLandingPage()
initializeAnalytics()

// The API was previously cached by Workbox. Remove that stale runtime cache so
// every booking, popup, and package request reaches the live backend directly.
if ('caches' in window) {
  window.caches.delete('api-cache').catch(() => undefined)
}

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
)

const rootElement = document.getElementById('root')

if (rootElement?.dataset.seoPrerender === 'true') {
  // The build/server SEO shell is intentionally framework-agnostic crawlable
  // HTML. Keep it visible until React commits the interactive application so
  // visitors never see a blank frame while the JavaScript bundle starts.
  createRoot(rootElement).render(app)
} else if (rootElement?.hasChildNodes()) {
  hydrateRoot(rootElement, app)
} else {
  createRoot(rootElement).render(app)
}
